import EMongoliaOtp from '@/components/page/emongoliaOtp'
import { TanCreateReq } from '@/services/mobi-api/sim/types'
import { FunctionComponent } from 'react'

interface Props {
  payload: TanCreateReq | undefined
}

const Step4: FunctionComponent<Props> = ({ payload }) => {
  return (
    <EMongoliaOtp
      instanceId={payload?.id}
      service='simRecovery'
    />
  )
}
export default Step4
